import { Plus } from '@phosphor-icons/react';
import { withMagneticIcon } from '../withMagneticIcon.js';

const Icon = withMagneticIcon(Plus);
Icon.displayName = "Plus";

export { Icon as Plus };
//# sourceMappingURL=Plus.js.map
